import type { SelectItemProps } from '@sola/ark-core/molecules/select/select.tsx';
import {
  COVER_CATEGORY_OPTIONS,
  GIFT_IDS,
} from '@sola/schema/lib/honor-card-constants.ts';

export const coverCategories =
  COVER_CATEGORY_OPTIONS as unknown as SelectItemProps[];

export const coverNumbers = Array.from({ length: 15 }, (_, i) => i + 1);

// Personal-note limits for the printable card's message panel: a line budget
// plus a hard character cap so the note always fits without overrunning the art.
export const NOTE_MAX_LINES = 8;
export const NOTE_CHARS_PER_LINE = 40;
export const NOTE_MAX_CHARS = 500;

export const coverCategoryTitleColor: Record<string, string> = {
  'merry-christmas': '#506963',
  birthday: '#6BBBDC',
  'thank-you': '#0096D1',
  'in-memory': '#6BBBDC',
  easter: '#A6A474',
  'mothers-day': '#E5A397',
  'fathers-day': '#215FAC',
  'in-your-honor': '#BEDEB5',
  'thinking-of-you': '#0167B1',
};

export const getBackgroundSrc = (category: string, number: number): string => {
  return `https://compassionmedia.com/card-maker/v10/background-${category}-${number}.webp`;
};

export const giftOptionValues: string[] = [...GIFT_IDS];
